function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// @patch SpeedDealActions
import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
export const styles = theme => ({
  /* Styles applied to the Fab component. */
  fab: {
    margin: theme.typography.pxToRem(8),
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
      backgroundColor: "rgba(26, 29, 33, 0.7)",
      "@media (hover: none)": {
        backgroundColor: "#000"
      }
    },
    transition: `${theme.transitions.create("transform", {
      duration: theme.transitions.duration.shorter
    })}, opacity 0.8s`,
    opacity: 1
  },

  /* Styles applied to the Fab component if `open={false}`. */
  fabClosed: {
    opacity: 0,
    transform: "scale(0)"
  }
});

const SpeedDialAction = function SpeedDialAction(props) {
  const {
    classes,
    className,
    delay = 0,
    FabProps,
    name,
    id,
    open,
    onClick
  } = props;
  const transitionStyle = {
    transitionDelay: `${delay}ms`
  };
  return /*#__PURE__*/React.createElement(Fab, _extends({
    size: "small",
    className: open ? FabProps.open : classes.fabClosed,
    classes: {
      root: clsx(className, classes.fab)
    },
    tabIndex: -1,
    onClick: onClick,
    role: "menuitem"
  }, FabProps, {
    style: { ...(!open && transitionStyle),
      ...FabProps.style
    },
    "aria-describedby": `${id}-label`
  }), name);
};

SpeedDialAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   */
  delay: PropTypes.number,

  /**
   * Props applied to the [`Fab`](/api/fab/) component.
   */
  FabProps: PropTypes.object,

  /**
   * The Icon to display in the SpeedDial Fab.
   */
  name: PropTypes.node,

  /**
   * @ignore
   */
  id: PropTypes.string,

  /**
   * @ignore
   */
  open: PropTypes.bool,
  onClick: PropTypes.func
};
export default withStyles(styles, {
  name: "MuiSpeedDialAction"
})(SpeedDialAction);